module.exports = __webpack_public_path__ + "static/img/russell-smith-keagan.8eb48dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/russell-smith-keagan.jpg
// module id = NA/n
// module chunks = 0